var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF8C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9628 20.6898C25.5347 20.5096 26.0361 20.1618 26.3994 19.6936C26.7627 19.2253 26.9701 18.6592 26.9938 18.0718C27.1276 16.2262 25.0766 15.1098 23.3828 14.6187L23.9489 11.9141L22.2463 11.5723L21.6847 14.2476L20.5447 14.0183L21.1031 11.3419L19.3993 11L18.841 13.6786L15.4136 12.9884L15.0532 14.7193L16.329 14.9757C16.9006 15.0903 17.145 15.3132 17.051 15.7654L15.4954 23.179C15.366 23.7978 15.0111 23.9244 14.6706 23.8552L13.3682 23.5945L13 25.3556L16.3102 26.021L15.7353 28.7612L17.4512 29.1041L18.0239 26.3639L19.1671 26.5932L18.5922 29.3335L20.2595 29.6667L20.8322 26.9264L21.197 27C24.6985 27.7043 26.2177 26.259 26.6964 23.9709C26.8188 23.3135 26.7156 22.635 26.4028 22.0409C26.0901 21.4469 25.5854 20.9707 24.9672 20.6865L24.9628 20.6898ZM20.16 15.8573L21.3761 16.1018C22.2264 16.2717 23.8826 16.7509 23.5874 18.1075C23.5262 18.5397 23.2988 18.9328 22.9516 19.2066C22.6044 19.4804 22.1635 19.6143 21.7189 19.5809L19.4701 19.1298L20.16 15.8573ZM20.2495 24.8007V24.7888L18.37 24.4112L19.1185 20.8412L21.3054 21.274C21.8173 21.3767 23.7024 21.9295 23.4238 23.2613C23.1452 24.593 22.0782 25.1707 20.2606 24.8039L20.2495 24.8007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.30f1a6609fac4409cd2f13de5bd6496c.svg";
export { ForwardRef as ReactComponent };